import axios from 'axios';
import { getCurrentUser } from 'aws-amplify/auth';

class PublicApiService {
    private apiClient: any;
    private baseURL: string = process.env.REACT_APP_API_URL || 'https://rdod17q8v9.execute-api.us-east-1.amazonaws.com/prod';

    constructor() {
        this.apiClient = axios.create({ baseURL: this.baseURL });

        // Attach interceptor to include Cognito token in headers
        this.apiClient.interceptors.request.use(async (config: any) => {
            return config;
        }, (error: any) => Promise.reject(error));
    }

    // General GET method
    async get(endpoint: string, params = {}) {
        try {
            const response = await this.apiClient.get(endpoint, { params });
            return response.data;
        } catch (error) {
            console.error('GET request failed:', error);
            throw error;
        }
    }

    // General POST method
    async post(endpoint: string, data = {}) {
        try {
            const response = await this.apiClient.post(endpoint, data);
            return response.data;
        } catch (error) {
            console.error('POST request failed:', error);
            throw error;
        }
    }

    // Specific API method: Post User Data
    async postConsentData(userData: any) {
        const endpoint = `/customer`;
        return await this.post(endpoint, userData);
    }

    // Specific API method: Fetch User Details
    async saveUserToken(code: string) {
        const currentUser = await getCurrentUser();
        const userName = currentUser.signInDetails?.loginId;
        const endpoint = `/oauth?code=${code}&state=${userName}`;
        return await this.get(endpoint);
    }

    async getUserAccount() {
        const endpoint = `/account`;
        return await this.get(endpoint);
    }

    async updateLocations(googleBusinessId: string, locations: []) {
        const endpoint = `/location`;
        const data = {
            BusinessId: googleBusinessId,
            SelectedLocations: locations
        }
        return await this.post(endpoint, data);
    }

    async saveContact(contactDetail: any) {
        const endpoint = `/contact`;
        return await this.post(endpoint, contactDetail);
    }
}

export default PublicApiService;

